import { Component, inject } from '@angular/core';
import { ReportIssueComponent } from '../report-issue/report-issue.component';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    ReportIssueComponent
  ],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  private readonly app = inject(AppService);

  currentYear = new Date().getFullYear();
  brandName = this.app.brandName;
  showCopyright = window.location.pathname !== '/' && !['/login', '/join'].some(_ => window.location.pathname.startsWith(_));
}
